/*
  Cards section grid slider new
*/

export function cardSectionSlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 767px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $('.cards-section.slider .cards-wrp').flickity({
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    cellAlign: cellAlignValue,
  });
}